var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEmailWhile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.834,
    height: 15.413,
    viewBox: "0 0 22.834 15.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_zocial-email",
    "data-name": "Icon zocial-email",
    d: "M.072,18.116V5.433q0-.022.066-.418L7.6,11.4.16,18.557a1.866,1.866,0,0,1-.088-.44ZM1.063,4.134a.949.949,0,0,1,.374-.066h20.1a1.247,1.247,0,0,1,.4.066l-7.487,6.408-.991.793L11.5,12.942,9.54,11.334l-.991-.793Zm.022,15.281,7.509-7.2L11.5,14.571l2.907-2.356,7.509,7.2a1.057,1.057,0,0,1-.374.066H1.437a1,1,0,0,1-.352-.066ZM15.4,11.4,22.84,5.015a1.314,1.314,0,0,1,.066.418V18.116a1.688,1.688,0,0,1-.066.44Z",
    transform: "translate(-0.072 -4.068)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailWhile);
export default __webpack_public_path__ + "static/media/icon-email-while.1af448d654c8e000c5e729b71c4be6dc.svg";
export { ForwardRef as ReactComponent };